export enum CampaignStatus {
    init = 'initialized',
    flyerStep = 'flyerStep',
    payed = 'payed',
    waitingForHOConfirmation = 'waitingForHOConfirmation',
    ordered = 'ordered'
}